import type { LeaseUnit } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from '../../root';

type TranslatedKeys = keyof Pick<LeaseUnit, 'establishment' | 'floorArea'>;

export const LEASE_UNIT_FIELDS_TRANSLATED = defineMessages<TranslatedKeys>({
  establishment: APP_DICTIONARY.establishment,
  floorArea: {
    id: 'app.common.leaseUnit.fields.area',
  },
});
